<div class="row">
    <div class="col-12">
        <div class="alert alert-warning" role="alert">
            <p class="mb-0"><i class="fas fa-lock"></i> Funcionalidades que necessitam de permissão para serem executadas.</p>
            <p class="mb-0"><strong>Selecione apenas as funcionalidades que este usuário possui permissão para executar.</strong></p>
        </div>
    </div>
</div>

<!-- Cadastros -->
<div class="row mb-4">
    <div class="col-12">
        <sgt-usuario-permissao-cadastro
            [entity]="entity">
        </sgt-usuario-permissao-cadastro>        
    </div>
</div>

<!-- Clientes -->
<div class="row mb-4">
    <div class="col-12">
        <sgt-usuario-permissao-cliente
            [entity]="entity">
        </sgt-usuario-permissao-cliente>
    </div>
</div>

<!-- Análises de Mercado -->
<div class="row mb-4">
    <div class="col-12">
        <sgt-usuario-permissao-analise-mercado
            [entity]="entity">
        </sgt-usuario-permissao-analise-mercado>
    </div>
</div>

<!-- Campanhas -->
<div class="row mb-4">
    <div class="col-12">
        <sgt-usuario-permissao-campanha
            [entity]="entity">
        </sgt-usuario-permissao-campanha>
    </div>
</div>

<!-- Metas -->
<div class="row mb-4">
    <div class="col-12">
        <sgt-usuario-permissao-meta
            [entity]="entity">
        </sgt-usuario-permissao-meta>
    </div>
</div>

<!-- PLM -->
<div class="row mb-4">
    <div class="col-12">
        <sgt-usuario-permissao-plm
            [entity]="entity">
        </sgt-usuario-permissao-plm>
    </div>
</div>

<!-- Pedidos -->
<div class="row mb-4">
    <div class="col-12">
        <sgt-usuario-permissao-pedido
            [entity]="entity"
            [isPerfilRepresentante]="isPerfilRepresentante">
        </sgt-usuario-permissao-pedido>
    </div>
</div>

<!-- Integrações -->
<div class="row mb-4">
    <div class="col-12">
        <sgt-usuario-permissao-integracao
            [entity]="entity"
            [isPerfilRepresentante]="isPerfilRepresentante">
        </sgt-usuario-permissao-integracao>
    </div>
</div>
